// Importación de librerías y módulos
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getDoc, updateDoc, doc } from "firebase/firestore";
import Header from '../HeaderAdmin';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db } from "../../firebase";

// Componente principal
const EventsEdit = () => {
  const [state, setState] = useState({
    nombre: '',
    descripcion: '',
    ubicacion: '',
    fecha: '',
    url: '',
    imagen: null
  });
  const [imageUploaded, setImageUploaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [previewUrl, setPreviewUrl] = useState(null);
  const navigate = useNavigate();    
  const { id } = useParams();
  const storage = getStorage();
  
  const update = async (e) => {
    e.preventDefault();
    const slide = doc(db, "eventos", id);
    const { imagen, ...rest } = state;
    let data = rest;
    if (imagen) {
      const storageRef = ref(storage, imagen.name);
      const snapshot = await uploadBytes(storageRef, imagen);
      const url = await getDownloadURL(snapshot.ref);
      data = { ...rest, url };
    }
    await updateDoc(slide, data);
    navigate('/admin-events');
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  // Función que maneja los cambios en la imagen

  const handleImagenChange = (e) => {
    const selectedFile = e.target.files[0];
    setState((prev) => ({ ...prev, imagen: selectedFile }));
    setPreviewUrl(URL.createObjectURL(selectedFile));
  };
  

  const getProductById = async (id) => {
    setIsLoading(true);
    const slide = await getDoc( doc(db, "eventos", id) );
    slide.exists() ? setState(slide.data()) : console.log('El producto no existe');
    setIsLoading(false);
  };

    // Función que sube la imagen a Firebase Storage
    const uploadImage = async () => {
      try {
        const storageRef = ref(storage, state.imagen.name);
        const snapshot = await uploadBytes(storageRef, state.imagen);
        const url = await getDownloadURL(snapshot.ref);
        setState((prev) => ({ ...prev, url: url }));
        setImageUploaded(true);
      } catch (error) {
        alert(error);
      }
    };
    
  useEffect( () => {
    getProductById(id);
  }, []);
  

    return (
        <div className='container'>
          <Header/>
        <div className='row'>
            <div className='col'>
                <h1>Editar Evento</h1>
                 <form onSubmit={update}>
                    <div className='mb-3'>
                        <label className='form-label'>Nombre</label>
                        <input
                            value={isLoading ? 'Cargando...' : state.nombre}
                            onChange={handleChange}
                            type="text"
                            name="nombre"
                            className='form-control'
                        />
                    </div>

                      <div className="mb-3">
              <label className="form-label">Descripcion</label>
              <input
                value={isLoading ? 'Cargando...' : state.descripcion}
                onChange={handleChange}
                type="text"
                name="descripcion"
                className="form-control size"
              />
            </div>  

            <div className="mb-3">
              <label className="form-label">Ubicacion</label>
              <input
                value={isLoading ? 'Cargando...' : state.ubicacion}
                onChange={handleChange}
                type="text"
                name="ubicacion"
                className="form-control size"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Fecha</label>
              <input
                value={isLoading ? 'Cargando...' : state.fecha}
                onChange={handleChange}
                type="date"
                name="fecha"
                className="form-control size"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Imagen</label>
              <input
                type="file"
                name="imagen"
                onChange={handleImagenChange}
                className="form-control size"
              />
              {isLoading ? 'Cargando...' : previewUrl && <img src={previewUrl} alt="Preview" style={{width:'300px', height:'auto'}}/>} 
            </div>
            {/* <div className="btn btn-primary" onClick={uploadImage}>UploadIMG</div>  */}
            <button className='btn btn-success' >Update</button>
                 </form>   
            </div>
        </div>
    </div> 
    )
}

export default EventsEdit